/* ============================================================
   OCOA Side Cart — interactivity
   - Subscribe / One-time toggle  -> /cart/change.js (selling plan)
   - "Pairs Well With"            -> /recommendations/products (section render)
   - Quick Add from recommendations
   - Mobile recommendations carousel arrows
   Reuses the theme's shapes:modalcart:* events so cart-items.js /
   cart-footer.js / cart-count.js morph the DOM after every mutation.
   ============================================================ */
(function () {
  'use strict';

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      add: r.cart_add_url || '/cart/add',
      change: r.cart_change_url || '/cart/change',
      update: r.cart_update_url || '/cart/update',
    };
  }
  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var SECTIONS_PLAN_SYNC = 'cart-footer,cart-item-count,cart-live-region';

  function postJSON(url, body) {
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function fire(name, data, target) {
    document.body.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: { response: data, originalTarget: target || null } })
    );
  }

  /* ---------- Subscribe / One-time toggle ----------
     Feels instant: on click we flip the buttons, price and saving immediately with NO
     dimming and NO waiting on the network. The /cart/change sync is DEBOUNCED so rapid
     toggles are never blocked and only the final choice is sent once the shopper settles
     (~350ms). Debouncing also means no section morph fires mid-interaction, so the line
     node + key stay valid (Shopify reassigns the line key whenever the plan changes).
     The single morph afterwards reconciles the totals + free-shipping bar. */
  var planSyncTimers = {};
  function setPlan(planEl, subscribe) {
    var key = planEl.getAttribute('data-oc-line-key');
    var planId = planEl.getAttribute('data-oc-plan-id');
    if (!key || (subscribe && !planId)) return;

    // instant optimistic UI (buttons)
    var sb = planEl.querySelector('[data-oc-plan-sub]');
    var ot = planEl.querySelector('[data-oc-plan-one]');
    if (sb && ot) {
      sb.classList.toggle('is-active', subscribe);
      ot.classList.toggle('is-active', !subscribe);
      sb.setAttribute('aria-pressed', subscribe);
      ot.setAttribute('aria-pressed', !subscribe);
    }
    // instant optimistic price + saving swap
    var line = planEl.closest('[data-cart-item-key]');
    if (line) {
      var nowSub = line.querySelector('[data-oc-now-sub]');
      var nowOne = line.querySelector('[data-oc-now-one]');
      if (nowSub) nowSub.hidden = !subscribe;
      if (nowOne) nowOne.hidden = subscribe;
      var saving = line.querySelector('[data-oc-saving]');
      if (saving) saving.hidden = !subscribe;
      // the plan-sync request deliberately skips re-rendering cart-items (see SECTIONS_PLAN_SYNC),
      // so this attribute must be flipped here or the gift sync never sees the new state
      line.setAttribute('data-oc-subscription-gift-qualifier', subscribe ? 'true' : 'false');
      line.setAttribute('data-oc-is-subscription', subscribe ? 'true' : 'false');
    }

    // debounced background sync — last click within the window wins
    clearTimeout(planSyncTimers[key]);
    planSyncTimers[key] = setTimeout(function () {
      delete planSyncTimers[key];
      var qty = 1;
      var input = line && line.querySelector('input[type="number"]');
      if (input) qty = parseInt(input.value, 10) || 1;
      postJSON(routes().change, {
        id: key,
        quantity: qty,
        selling_plan: subscribe ? planId : null,
        sections: SECTIONS_PLAN_SYNC,
        sections_url: window.location.pathname,
      })
        .then(function (data) {
          fire('shapes:modalcart:cartqtychange', data, line);
        })
        .catch(function () {});
    }, 350);
  }

  /* ---------- Pre-order (EP, Nov 1 2026) ----------
     window.ocPreorder comes from snippets/drawer-cart.liquid and exists only while the kit
     is on pre-order. Quick adds and card forms carry the same "Pre-order" line property
     as the product page, so checkout and the order show the ship date. */
  function isPreorder(id) {
    return !!window.ocPreorder && String(window.ocPreorder.id) === String(id);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var idField = form.querySelector('[name="id"]');
    if (!idField || !isPreorder(idField.value)) return;
    if (form.querySelector('[name="properties[Pre-order]"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Pre-order]';
    input.value = window.ocPreorder.ship;
    form.appendChild(input);
  }, true);

  /* ---------- Quick Add (recommendations) ---------- */
  function quickAdd(btn) {
    var id = btn.getAttribute('data-oc-add');
    if (!id || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    btn.classList.add('is-adding');
    var recoItem = { id: id, quantity: 1 };
    if (isPreorder(id)) recoItem.properties = { 'Pre-order': window.ocPreorder.ship };
    postJSON(routes().add, { items: [recoItem], sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (data) {
        fire('shapes:modalcart:afteradditem', data, btn);
        loadRecommendations();
      })
      .catch(function () {})
      .finally(function () {
        btn.classList.remove('is-adding');
        delete btn.dataset.busy;
      });
  }

  /* ---------- Home/collection quick-add (QA #01) ----------
     The homepage "Best Sellers" cards are wrapped in a link to the PDP. The "Add To Cart"
     button carries data-oc-quickadd="<variant id>"; we intercept it, stop the link
     navigation, AJAX-add, and open the sidecart in place. */
  function openDrawer() {
    try {
      var m = window.Alpine && window.Alpine.store && window.Alpine.store('modals');
      if (!m) return;
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
      if (typeof m.open === 'function') m.open('rightDrawer', 'cart');
      if (m.rightDrawer) m.rightDrawer.contents = 'cart';
    } catch (e) {}
  }
  function homeQuickAdd(el) {
    var id = el.getAttribute('data-oc-quickadd');
    if (!id || el.dataset.ocBusy) return;
    el.dataset.ocBusy = '1';
    el.classList.add('is-adding');
    var item = { id: id, quantity: 1 };
    var plan = el.getAttribute('data-oc-selling-plan');
    if (plan) item.selling_plan = plan;
    if (isPreorder(id)) item.properties = { 'Pre-order': window.ocPreorder.ship };
    postJSON(routes().add, { items: [item], sections: SECTIONS, sections_url: window.location.pathname })
      .then(function (data) { fire('shapes:modalcart:afteradditem', data, el); openDrawer(); loadRecommendations(); })
      .catch(function () {})
      .finally(function () { el.classList.remove('is-adding'); delete el.dataset.ocBusy; });
  }

  /* ---------- delegated clicks ----------
     CAPTURE phase is required: the theme's #right-drawer-slot uses Alpine
     @click.stop (bubble-phase stopPropagation), which would otherwise prevent
     these document-level handlers from ever seeing clicks inside the drawer. */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-oc-quickadd]');
    if (qa) { e.preventDefault(); e.stopPropagation(); homeQuickAdd(qa); return; }
    var sub = e.target.closest('[data-oc-plan-sub]');
    var one = e.target.closest('[data-oc-plan-one]');
    var add = e.target.closest('[data-oc-add]');
    if (sub && !sub.classList.contains('is-active')) { e.preventDefault(); setPlan(sub.closest('[data-oc-plan]'), true); return; }
    if (one && !one.classList.contains('is-active')) { e.preventDefault(); setPlan(one.closest('[data-oc-plan]'), false); return; }
    if (add) { e.preventDefault(); quickAdd(add); }
  }, true);

  /* ---------- promotional gifts ----------
     Two independent gift rules are kept in sync from the rendered cart:
     1) One one-time gift with a qualifying subscription line from the custom PDP.
     2) The existing cart-threshold gift, controlled by Theme settings.
     Gift lines carry private line-item properties so they never get confused with a
     customer purchasing the same product normally. */
  var giftSyncBusy = false;
  var giftSyncQueued = false;
  var giftSyncTimer = null;

  function boolAttr(el, name) {
    return !!el && el.getAttribute(name) === 'true';
  }

  function intAttr(el, name) {
    var n = parseInt(el && el.getAttribute(name), 10);
    return isNaN(n) ? 0 : n;
  }

  function giftCartState() {
    var config = document.querySelector('[data-oc-gift-config]');
    if (!config) return null;

    var scope = config.closest('[data-cart-items]') || document;
    var lines = Array.prototype.slice.call(scope.querySelectorAll('.oc-line[data-oc-line-key]'));
    var state = {
      config: config,
      qualifyingSubtotal: intAttr(config, 'data-oc-qualifying-subtotal'),
      subscriptionEnabled: boolAttr(config, 'data-oc-subscription-gift-enabled'),
      subscriptionVariant: intAttr(config, 'data-oc-subscription-gift-variant'),
      bundleMassager: boolAttr(config, 'data-oc-bundle-massager'),
      thresholdEnabled: boolAttr(config, 'data-oc-threshold-gift-enabled'),
      threshold: intAttr(config, 'data-oc-threshold-gift-threshold'),
      thresholdVariant: intAttr(config, 'data-oc-threshold-gift-variant'),
      hasQualifyingSubscription: false,
      bundleProducts: 0,
      bundleGiftLines: [],
      subscriptionGiftLines: [],
      thresholdGiftLines: []
    };

    lines.forEach(function (line) {
      var isSub = boolAttr(line, 'data-oc-is-subscription');
      var qualifies = boolAttr(line, 'data-oc-subscription-gift-qualifier');
      if (isSub && qualifies) state.hasQualifyingSubscription = true;
      if (boolAttr(line, 'data-oc-bundle-product')) state.bundleProducts += intAttr(line, 'data-oc-line-quantity');
      if (boolAttr(line, 'data-oc-bundle-gift')) state.bundleGiftLines.push(line);
      if (boolAttr(line, 'data-oc-subscription-gift')) state.subscriptionGiftLines.push(line);
      if (boolAttr(line, 'data-oc-threshold-gift')) state.thresholdGiftLines.push(line);
    });

    return state;
  }

  function normalizeGiftLines(lines, desiredQty, updates) {
    lines.forEach(function (line, index) {
      var key = line.getAttribute('data-oc-line-key');
      var current = intAttr(line, 'data-oc-line-quantity');
      var wanted = index === 0 ? desiredQty : 0;
      if (key && current !== wanted) updates[key] = wanted;
    });
  }

  function finishGiftSync() {
    giftSyncBusy = false;
    if (giftSyncQueued) {
      giftSyncQueued = false;
      scheduleGiftSync(90);
    }
  }

  function syncPromotionalGifts() {
    if (giftSyncBusy) {
      giftSyncQueued = true;
      return;
    }

    var state = giftCartState();
    if (!state) return;

    // the bundle's own Scalp Massager replaces the first-subscription one (never two massagers)
    var wantSubscriptionGift = state.subscriptionEnabled && state.subscriptionVariant > 0 && state.hasQualifyingSubscription && !state.bundleMassager;
    var wantThresholdGift = state.thresholdEnabled && state.thresholdVariant > 0 && state.threshold > 0 && state.qualifyingSubtotal >= state.threshold;
    var updates = {};

    // Bundle gifts only live with the bundle products that earn them (tote 3+, massager 4+, from the
    // line's own _ocoa_bundle_gift_min): removing products anywhere in the cart removes the gifts.
    state.bundleGiftLines.forEach(function (line) {
      var key = line.getAttribute('data-oc-line-key');
      var min = intAttr(line, 'data-oc-bundle-gift-min') || 3;
      if (key && state.bundleProducts < min) updates[key] = 0;
    });
    normalizeGiftLines(state.subscriptionGiftLines, wantSubscriptionGift ? 1 : 0, updates);
    normalizeGiftLines(state.thresholdGiftLines, wantThresholdGift ? 1 : 0, updates);

    if (Object.keys(updates).length) {
      giftSyncBusy = true;
      postJSON(routes().update, {
        updates: updates,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
        .then(function (data) {
          if (data && data.sections) fire('shapes:modalcart:cartqtychange', data);
        })
        .catch(function () {})
        .finally(finishGiftSync);
      return;
    }

    var items = [];
    if (wantSubscriptionGift && state.subscriptionGiftLines.length === 0) {
      items.push({
        id: state.subscriptionVariant,
        quantity: 1,
        properties: { _ocoa_subscription_gift: 'true' }
      });
    }
    if (wantThresholdGift && state.thresholdGiftLines.length === 0) {
      items.push({
        id: state.thresholdVariant,
        quantity: 1,
        properties: { _ocoa_threshold_gift: 'true' }
      });
    }

    if (!items.length) return;

    giftSyncBusy = true;
    postJSON(routes().add, {
      items: items,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        if (data && data.sections) fire('shapes:modalcart:cartqtychange', data);
      })
      .catch(function () {})
      .finally(finishGiftSync);
  }

  function scheduleGiftSync(delay) {
    clearTimeout(giftSyncTimer);
    giftSyncTimer = setTimeout(syncPromotionalGifts, typeof delay === 'number' ? delay : 90);
  }

  /* ---------- recommendations ----------
     Cart data is read from the rendered line items (DOM), NOT /cart.js —
     this store proxies /cart.js to HTML, so we avoid it entirely. */
  var recoBusy = false;
  var recoCache = []; // card outerHTML from the last successful fetch (persisted across re-teleports/reloads)
  try { var _rc = sessionStorage.getItem('ocoaRecoCards'); if (_rc) recoCache = JSON.parse(_rc) || []; } catch (e) {}

  function cartSeedAndIds() {
    var lines = Array.prototype.slice.call(document.querySelectorAll('.oc-line[data-oc-product-id]'));
    var inCart = {};
    lines.forEach(function (l) { inCart[l.getAttribute('data-oc-product-id')] = true; });
    var seed = lines.length ? lines[lines.length - 1].getAttribute('data-oc-product-id') : null;
    return { seed: seed, inCart: inCart };
  }
  // Fill reco mounts. force=false only fills EMPTY mounts (used on open/re-teleport so we
  // never clobber good cards); force=true refreshes with freshly fetched cards.
  function fillRecoLists(cardHTMLs, force) {
    var lists = document.querySelectorAll('[data-oc-reco-list]');
    if (!lists.length || !cardHTMLs || !cardHTMLs.length) return;
    lists.forEach(function (list) {
      if (!force && list.children.length) return;
      var isDesktop = !!list.closest('.ocoa-cart__aside');
      var slice = isDesktop ? cardHTMLs.slice(0, 3) : cardHTMLs.slice(0, 10);
      list.innerHTML = slice.join('');
      var mobileReco = list.closest('.oc-reco--mobile');
      if (mobileReco) mobileReco.style.display = slice.length ? '' : 'none';
    });
    updateRecoArrows();
  }
  function fetchReco(attempt) {
    attempt = attempt || 0;
    if (attempt === 0 && recoBusy) return;
    if (!document.querySelector('[data-oc-reco-list]')) { recoBusy = false; return; }
    var info = cartSeedAndIds();
    if (!info.seed) { recoBusy = false; return; }
    recoBusy = true;
    var url = '/recommendations/products?product_id=' + info.seed + '&limit=10&intent=related&section_id=ocoa-cart-recommendations';
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var cards = Array.prototype.slice.call(new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.oc-card'))
          .filter(function (c) { var pid = c.getAttribute('data-oc-card-product'); return !pid || !info.inCart[pid]; })
          .map(function (c) { return c.outerHTML; });
        if (cards.length) {
          recoCache = cards;
          try { sessionStorage.setItem('ocoaRecoCards', JSON.stringify(cards)); } catch (e) {}
          fillRecoLists(cards, true);
          recoBusy = false;
        } else if (attempt < 2) {
          setTimeout(function () { fetchReco(attempt + 1); }, 700); // Shopify reco index can lag right after edits
        } else { recoBusy = false; }
      })
      .catch(function () { if (attempt < 2) setTimeout(function () { fetchReco(attempt + 1); }, 700); else recoBusy = false; });
  }
  // Instant: paint cached cards into any empty mount, then refresh from the network.
  function loadRecommendations() {
    syncEmptyState();
    fillRecoLists(recoCache, false);
    fetchReco(0);
  }

  // Toggle an empty-cart flag so the desktop "Pairs Well With" aside can hide when there
  // are no line items (the empty-state CTA + suggestions live in the main column instead).
  function syncEmptyState() {
    document.querySelectorAll('.ocoa-cart').forEach(function (c) {
      c.classList.toggle('oc-is-empty', !c.querySelector('.oc-line'));
    });
  }

  /* ---------- cart re-hydration on bfcache restore (QA #04) ----------
     Back/forward navigation can restore a cached page whose drawer was rendered from a
     stale (often empty) cart. Re-fetch the cart sections for the current cart and morph. */
  function rehydrateCart() {
    /* Must hit /cart, not the current page's own path — cart-items/cart-footer/etc.
       are sections of the cart template, not of arbitrary pages, so requesting them
       against e.g. a product page silently returns unrelated data. The Accept header
       must also be left off: Accept: application/json on /cart returns the plain cart
       object (ignoring ?sections=) instead of the rendered section HTML this needs. */
    fetch('/cart?sections=' + SECTIONS)
      .then(function (r) { return r.json(); })
      .then(function (sections) { fire('shapes:modalcart:cartqtychange', { sections: sections }); loadRecommendations(); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) rehydrateCart(); });

  /* ---------- mobile recommendations carousel ---------- */
  function updateRecoArrows() {
    document.querySelectorAll('.oc-reco--mobile .oc-reco__railwrap').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-oc-reco-list]');
      var prev = wrap.querySelector('[data-oc-reco-prev]');
      var next = wrap.querySelector('[data-oc-reco-next]');
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth;
      prev.hidden = rail.scrollLeft <= 2;
      next.hidden = rail.scrollLeft >= max - 2;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oc-reco-prev],[data-oc-reco-next]');
    if (!btn) return;
    var wrap = btn.closest('.oc-reco__railwrap');
    var rail = wrap && wrap.querySelector('[data-oc-reco-list]');
    if (!rail) return;
    var card = rail.querySelector('.oc-card');
    var step = card ? card.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: btn.hasAttribute('data-oc-reco-next') ? step : -step, behavior: 'smooth' });
  }, true);
  document.addEventListener('scroll', function (e) {
    if (e.target.closest && e.target.matches && e.target.matches('[data-oc-reco-list]')) updateRecoArrows();
  }, true);

  /* ---------- discount code badge (footer) ----------
     cart.discount_codes is populated by the AJAX Cart API (confirmed via /cart.js: an
     applicable TRIOSHIP code shows up there) but NOT by this theme's server-rendered
     Liquid `cart` object (confirmed empty via a debug probe on the exact same cart, in
     both the full-page render and the cart/change.js section-render path) — so this
     badge is built entirely from the AJAX cart JSON rather than Liquid.
     Lives as a small pill next to the "Subtotal" label (snippets/ocoa-cart-footer.liquid),
     matching the existing chip visual language (oc-discount-badge, modeled on
     sections/ocoa-trio-hero.liquid .tg-chip) rather than a standalone row. That label sits
     inside [data-cart-footer], which — like the whole footer root — gets Alpine.morph'd by
     cart-footer.js on every shapes:modalcart:* event, which would stomp our JS-set content
     if we wrote it synchronously within the same dispatch (order between that listener and
     this one isn't guaranteed). Deferring with setTimeout(0) lets the morph finish first.
     The amount only ever shows a number we can prove from real cart data: a true
     order-level discount code (cart_level_discount_applications, type 'discount_code')
     gives its real total_allocated_amount. A code that's applicable but not attributable
     to a cart-level price reduction (e.g. TRIOSHIP, a shipping-only code — shipping has
     no pre-checkout dollar amount) falls back to a plain "{code} applied" pill with no
     amount, instead of guessing a number. */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var valueNoDecimals = Math.round(cents / 100).toString();
    var valueWithComma = value.replace('.', ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, valueNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, valueWithComma)
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }
  // Order-level automatic discounts (e.g. "$10 off $75+") as rows above the Total
  function renderOrderDiscounts(cart) {
    if (!cart || !cart.cart_level_discount_applications) return;
    var rows = '';
    cart.cart_level_discount_applications.forEach(function (da) {
      if (da && da.type !== 'discount_code' && da.total_allocated_amount > 0) {
        var t = String(da.title || 'Discount').replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
        rows += '<div class="oc-foot__line oc-foot__line--discount"><span>' + t + '</span><span>-' + formatMoney(da.total_allocated_amount) + '</span></div>';
      }
    });
    document.querySelectorAll('[data-oc-order-discounts]').forEach(function (el) { el.innerHTML = rows; });
  }

  function renderDiscountBanner(cart) {
    if (!cart) return;
    renderOrderDiscounts(cart);
    document.querySelectorAll('[data-oc-discount-banner]').forEach(function (el) {
      var msgEl = el.querySelector('[data-oc-discount-banner-msg]');
      var amtEl = el.querySelector('[data-oc-discount-banner-amt]');
      if (!msgEl || !amtEl) return;

      var code = '';
      (cart.discount_codes || []).some(function (dc) {
        if (dc && dc.applicable && dc.code) { code = dc.code; return true; }
        return false;
      });

      if (!code) {
        el.hidden = true;
        msgEl.textContent = '';
        amtEl.textContent = '';
        return;
      }

      var amountCents = 0;
      (cart.cart_level_discount_applications || []).forEach(function (da) {
        if (da && da.type === 'discount_code' && da.total_allocated_amount > 0) {
          amountCents = da.total_allocated_amount;
        }
      });

      msgEl.textContent = code + ' applied';
      amtEl.textContent = amountCents > 0 ? ' -' + formatMoney(amountCents) : '';
      el.hidden = false;
    });
  }
  function refreshDiscountBanner(cartData) {
    // Deferred: [data-cart-footer] (where this line now lives) gets Alpine.morph'd by
    // cart-footer.js on the same shapes:modalcart:* events this fires from, and listener
    // order between that module and this one isn't guaranteed — see comment above.
    setTimeout(function () {
      if (cartData && cartData.discount_codes !== undefined) {
        renderDiscountBanner(cartData);
        return;
      }
      // No usable cart payload on this event (e.g. rehydrateCart only sends {sections},
      // and the initial page load / drawer-open have no mutation payload at all) — fetch it.
      fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDiscountBanner).catch(function () {});
    }, 0);
  }

  /* ---------- triggers ---------- */
  var refreshReco = function () { setTimeout(loadRecommendations, 80); };
  var refreshCartEnhancements = function (e) {
    refreshReco();
    scheduleGiftSync(110);
    refreshDiscountBanner(e && e.detail && e.detail.response);
  };
  // cart mutations -> refetch recommendations and reconcile both gift rules
  window.addEventListener('shapes:modalcart:afteradditem', refreshCartEnhancements);
  window.addEventListener('shapes:modalcart:cartqtychange', refreshCartEnhancements);
  // every drawer open (incl. re-teleport, which creates empty mounts) -> paint from cache + reconcile gifts
  window.addEventListener('right-drawer-is-open', refreshCartEnhancements);
  // safety net: if the drawer is re-teleported (new empty mounts), repaint from cache immediately
  if (window.MutationObserver) {
    try {
      new MutationObserver(function () {
        var aside = document.querySelector('.ocoa-cart__aside [data-oc-reco-list]');
        if (aside && !aside.children.length && recoCache.length) fillRecoLists(recoCache, false);
      }).observe(document.body, { childList: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadRecommendations();
      scheduleGiftSync(140);
      refreshDiscountBanner();
    });
  } else {
    loadRecommendations();
    scheduleGiftSync(140);
    refreshDiscountBanner();
  }
})();

/* Mirror the cart drawer's open/closed state onto <body class="oc-cart-open"> so CSS can
   hide the floating third-party widgets (Gorgias chat, Quinn video reel, Klaviyo teaser)
   that otherwise stack above the drawer. The drawer's modal container stays display:block
   even when closed, so we track the reactive Alpine store (modals.rightDrawer.open), which
   flips true/false on open/close. */
(function () {
  function bind() {
    if (!(window.Alpine && Alpine.store && Alpine.store('modals') && Alpine.effect)) { return false; }
    Alpine.effect(function () {
      var s = Alpine.store('modals');
      var open = !!(s && s.rightDrawer && s.rightDrawer.open);
      document.body.classList.toggle('oc-cart-open', open);
    });
    return true;
  }
  if (!bind()) {
    document.addEventListener('alpine:initialized', bind);
    // fallback if alpine:initialized already fired before this script ran
    var tries = 0, t = setInterval(function () { if (bind() || ++tries > 40) { clearInterval(t); } }, 100);
  }
})();

/* ---------- Alia popup scroll-lock watchdog (QA, 4 Oct) ----------
   Michael: "there is a bug when I close the alia popup it doesn't let me scroll up or
   down." Alia is a third-party app (Settings > Apps > Alia, embed block
   shopify://apps/alia/blocks/customer-app-frame) injected via content_for_header -- its
   script is served fresh from backend.alia-prod.com on every load, so we can't edit it
   directly, and nothing here runs inside it.

   Reading Alia's own bundle (public/app.js, the PopupRoot component) confirms it locks
   scroll itself: when its modal/popup opens it does
   document.body.style.setProperty('overflow','hidden') (and, on iOS Safari 26.x only,
   the same plus position:absolute/inset:0 on <html>), then relies on a React effect
   cleanup to remove those same properties when the popup unmounts. That cleanup is
   Alia's own code, not always reached (e.g. some close paths don't unmount the popup,
   just hide it), which is what leaves the page stuck unscrollable after close -- this is
   a bug in Alia's own script, not a conflict with Ocoa's own modal system (the cart/left
   drawers lock scroll separately, via Alpine's battle-tested x-trap.noscroll on <html>,
   never touching body.style.overflow).

   Fix: watch Alia's own root node (id^="alia-root-") for changes. Whenever it changes,
   wait a beat for Alia's own close animation/cleanup to finish, then check whether Alia
   still looks open (its collapsed launcher pill is small; its popup is not) and whether
   any of OUR OWN modals are open (Alpine store) -- only if BOTH are false do we release a
   leftover inline overflow:hidden. This never fires while a real modal (ours or Alia's)
   is actually open. */
(function () {
  var RELEASE_DELAY = 600;
  var sweepTimer = null;

  function ocoaModalOpen() {
    var s = window.Alpine && Alpine.store && Alpine.store('modals');
    if (!s) return false;
    return !!(
      (s.leftDrawer && s.leftDrawer.open) ||
      (s.rightDrawer && s.rightDrawer.open) ||
      (s.modal && s.modal.open) ||
      (s.popup && s.popup.open)
    );
  }

  function aliaLooksOpen(root) {
    if (!root) return false;
    var r = root.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false; // hidden entirely
    // Alia's collapsed launcher pill is a small corner bubble (~150x55 observed);
    // its actual popup/modal is a full card (--app-width: 360px) and noticeably taller.
    return r.height > 120 || r.width > 220;
  }

  function releaseIfStuck() {
    var root = document.querySelector('[id^="alia-root-"]');
    if (aliaLooksOpen(root)) return; // Alia's own popup is legitimately open
    if (ocoaModalOpen()) return;     // one of our own modals owns the lock right now

    if (document.body.style.overflow === 'hidden') {
      document.body.style.removeProperty('overflow');
    }
    // Only Alia's iOS-Safari-26 workaround touches <html>, and only alongside
    // position:absolute -- check both so we never touch an unrelated inline style.
    if (
      document.documentElement.style.overflow === 'hidden' &&
      document.documentElement.style.position === 'absolute'
    ) {
      document.documentElement.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('position');
      document.documentElement.style.removeProperty('inset');
    }
  }

  function scheduleCheck() {
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(releaseIfStuck, RELEASE_DELAY);
  }

  function watch() {
    var root = document.querySelector('[id^="alia-root-"]');
    if (!root) return false;
    new MutationObserver(scheduleCheck).observe(root, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true,
    });
    // Cheap periodic safety net in case Alia mutates in a way the observer misses.
    setInterval(releaseIfStuck, 5000);
    return true;
  }

  if (!watch()) {
    var tries = 0, t = setInterval(function () { if (watch() || ++tries > 40) { clearInterval(t); } }, 250);
  }
})();